import * as React from 'react';
import * as ReactDOM from 'react-dom';
import $ = require('jquery');
import {Container, computeContainerWidth} from './components/Container';
import {Mode as LimitationsMode} from './components/Limitations';
import {Category} from './data';

interface ResponsiveParams {
    columnsNo: number;
    showSidebar: boolean;
}

/**
 * Maps viewport width upper limit to params
 *
 * !! Keys should be in ascending order
 */
const responsiveParamMap = new Map<number, ResponsiveParams>()
    .set(768, {
        columnsNo: 1,
        showSidebar: false,
    })
    .set(1000, {
        columnsNo: 2,
        showSidebar: false
    })
    .set(1400, {
        columnsNo: 2,
        showSidebar: true
    })
    .set(Number.MAX_VALUE, {
        columnsNo: 3,
        showSidebar: true
    });

export default class SectionSelector {
    private categories: Category[];
    private contentEl: HTMLElement;
    private responsiveParams: ResponsiveParams;

    afterFillContent(el: HTMLElement, data: Category[], contentElement: JQuery) {
        this.categories = data;
        this.contentEl = contentElement.get(0);

        this.render();
    }

    show() {
        this.updateResponsiveParams();
        $(window).on('resize.sectionSelector', () => {
            this.updateResponsiveParams();
            this.render();
        });
        if (this.contentEl) {
            this.render();
        }
    }

    hide() {
        $(window).off('.sectionSelector');
    }

    getWindowSize() {
        this.updateResponsiveParams();

        return {
            width: computeContainerWidth(this.responsiveParams.columnsNo,
                this.responsiveParams.showSidebar),
            height: 650
        };
    }

    private getViewportWidth() {
        return window.innerWidth;
    }

    private updateResponsiveParams() {
        let targetWidth = this.getViewportWidth();
        this.responsiveParams = Array.from(responsiveParamMap).find(
            ([viewportWidth]) => (targetWidth < viewportWidth)
        )[1];
    }

    private render() {
        ReactDOM.render(
            <Container categories={this.categories}
                initialCategory={this.categories[0]}
                columnsNo={this.responsiveParams.columnsNo}
                showSidebar={this.responsiveParams.showSidebar}
                limitationsMode={this.getLimitationsMode()} />,
            this.contentEl
        );
    }

    private isModuleLimitReached() {
        return $("#cc-sa-sidebar").hasClass('modules-maximum');
    }

    private isModuleLimitWarning() {
        return $("#cc-sa-sidebar").hasClass('modules-critical');
    }

    private getLimitationsMode() {
        if (this.isModuleLimitReached()) {
            return LimitationsMode.Maximum;
        }

        if (this.isModuleLimitWarning()) {
            return LimitationsMode.Critical;
        }

        return LimitationsMode.None;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/section-selector/SectionSelector.tsx
 **/